<div class="trigger-item-header">{{'general.note_deposit_trigger' | stringLiterals}}</div>
<div class="trigger-item-row">
    <tam-single-select-dropdown-filter [dropdownConfig]="noteDepositEntityTypeConfig">
        <ng-template #customContent>
            <div class="selected-item">
                <a (click)="onSelectEntityTypeClick($event)">{{selectedEntityTypeName}}</a>
            </div>
        </ng-template>
    </tam-single-select-dropdown-filter>
</div>
<div class="trigger-item-row">
    <div class="selected-item">
        <a (click)="onFilterCriteriaClick($event)">{{'general.filter_criteria' | stringLiterals}} ({{filterNum}})</a>
    </div>
</div>
<div class="trigger-item-row">
    <div class="selected-item">
        <a (click)="onMetaMappingClick($event)">{{'general.meta_mapping' | stringLiterals}} ({{metaNum}})</a>
    </div>
</div>
<tam-note-deposit-trigger-filter-dialog></tam-note-deposit-trigger-filter-dialog>
<tam-note-deposit-trigger-meta-dialog></tam-note-deposit-trigger-meta-dialog>